import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    BACK_NOTIFICACIONES_GET : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.notificaciones.get'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_NOTIFICACIONES_MARCAR_COMO_LEIDAS : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.notificaciones.marcar-como-leidas'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_NOTIFICACIONES_MARCAR_COMO_LEIDA : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.notificaciones.marcar-como-leida'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    }
}

export default {
    actions
};